<app-orders-table
  [dataSource]="dataSource"
  [orderState]="OrderStateEnum.Scheduled"
  [warehouses]="warehouses"
  [businesses]="businesses"
  [allowRestartLottery]="true"
  [displayedColumns]="displayedColumns"
  (tableActionTaken)="handleTableAction($event)"
></app-orders-table>
